import 'firebase/database';
import 'firebase/auth';
import firebase from 'firebase/app';


// GET CONTRACTS
export const GET_PLANOGRAMS_PENDING = 'GET_PLANOGRAMS_PENDING';
export const GET_PLANOGRAMS_FULFILLED = 'GET_PLANOGRAMS_FULFILLED';
export const GET_PLANOGRAMS_REJECTED = 'GET_PLANOGRAMS_REJECTED';

export const UPLOAD_PLANOGRAM_PENDING = 'UPLOAD_PLANOGRAM_PENDING';
export const UPLOAD_PLANOGRAM_FULFILLED= 'UPLOAD_PLANOGRAM_FULFILLED';
export const UPLOAD_PLANOGRAM_REJECTED = 'UPLOAD_PLANOGRAM_REJECTED';

export const DELETE_PLANOGRAM_PENDING = 'DELETE_PLANOGRAM_PENDING';
export const DELETE_PLANOGRAM_FULFILLED = 'DELETE_PLANOGRAM_FULFILLED';
export const DELETE_PLANOGRAM_REJECTED = 'DELETE_PLANOGRAM_REJECTED';

//PLANOGRAM RETRIEVAL

const getPlanograms = (equipmentId) => (dispatch) => {

    dispatch({
        type: GET_PLANOGRAMS_PENDING
    });

    var ref = firebase.database().ref('planograms').child(localStorage.getItem('companyID'));
    ref.orderByChild('equipmentID').equalTo(equipmentId).once('value', snapshot => {
        let planograms = snapshot.val();

        var planogramsWithIds = [];
        if (planograms != null) {
            planogramsWithIds = Object.keys(planograms).map((planogramId) => { 
                let planogram = planograms[planogramId];
                planogram['id'] = planogramId;
                return planogram;
            });
        }

        dispatch({
            type: GET_PLANOGRAMS_FULFILLED,
            payload: planogramsWithIds
        });

    }).catch((error) => {
        dispatch({
            type: GET_PLANOGRAMS_REJECTED,
            payload: error
        });
    });
};

const uploadPlanogram = (planogram) => (dispatch) => {

    dispatch({
        type: UPLOAD_PLANOGRAM_PENDING
    });

    let newPostKey = firebase.database().ref('planograms').child(localStorage.getItem('companyID')).push().key;
    var updates = {};
    updates['/planograms/' + localStorage.getItem('companyID') + '/' + newPostKey] = planogram;
    firebase.database().ref().update(updates);

    dispatch({
        type: UPLOAD_PLANOGRAM_FULFILLED
    });
};

const deletePlanogram = (planogramId) => (dispatch) => {
    dispatch({
        type: DELETE_PLANOGRAM_PENDING
    });

    firebase.database().ref('planograms').child(localStorage.getItem('companyID')).child(planogramId).set(null);

    dispatch({
        type: DELETE_PLANOGRAM_FULFILLED,
        payload: planogramId
    });
};

export { getPlanograms, uploadPlanogram, deletePlanogram };


// WEBPACK FOOTER //
// ./src/components/state/actions/PlanogramActions.js